import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, ContractStatus } from '../../authentication.service';

@Component({
  selector: 'kgr-avoid-component-id-collision-institution-redirect-customer-apps',
  templateUrl: './institution-redirect.component.html',
  styleUrls: ['./institution-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InstitutionRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    const target = this.route.snapshot.queryParams['target'] ?? '/';
    const institutionId = this.route.snapshot.params['institutionId'];

    if (!institutionId) {
      throw new Error(`Cannot redirect to institution - missing institutionId parameter`);
    }

    const institutionIdNumeric = parseInt(institutionId, 10);
    if (isNaN(institutionIdNumeric)) {
      throw new Error(`Cannot redirect to institution with invalid id "${institutionId}"`);
    }

    this.authenticationService.readLoginUserTokens().subscribe((loginUserTokens) => {
      const loginUserTokenForInstitution = loginUserTokens
        .filter(
          (loginUserToken) =>
            loginUserToken.contractStatus === null ||
            loginUserToken.contractStatus === undefined ||
            loginUserToken.contractStatus === ContractStatus.running,
        )
        .find((loginUserToken) => loginUserToken.institutionId === institutionIdNumeric);

      if (loginUserTokenForInstitution && this.authenticationService.loginByToken(loginUserTokenForInstitution.token)) {
        console.log('switched institution, redirect to', target);
        this.router.navigateByUrl(target, { replaceUrl: true });
      } else {
        this.router.navigate(['/user/login'], { replaceUrl: true });
      }
    });
  }
}
